// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2637":"6115718c","4157":"9bb09147","5941":"ef32d93d","9454":"7b91958f","9512":"a8b825f2"}[chunkId] + ".chunk.css";
};